import React from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { FaLightbulb, FaRocket, FaUsers, FaMapMarkedAlt } from "react-icons/fa";
import "../styles/about.css";
import sunilImg from "../assets/director.jpg"; // ✅ Director image from assets

const About = () => {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const particlesOptions = {
    fullScreen: { enable: true },
    background: {
      color: { value: "#0b0c10" },
    },
    particles: {
      number: { value: 60 },
      color: { value: "#00f9ff" },
      shape: { type: "circle" },
      opacity: { value: 0.3 },
      size: { value: 3 },
      move: {
        enable: true,
        speed: 0.5,
        direction: "none",
        outModes: { default: "bounce" },
      },
    },
  };

  return (
    <div className="about-page">
      {/* Background particle effect */}
      <Particles className="particles-bg" init={particlesInit} options={particlesOptions} />

      <div className="about-container">
        <h1 className="about-title">About NEELAverse Technologies</h1>
        <p className="about-intro">
          NEELAverse Technologies is not just a company – it’s a vision. Founded by tech enthusiasts with a passion
          for creating impactful digital solutions, we stand at the forefront of innovation, offering modern
          software services that drive results. From startups to enterprises, our commitment is to deliver
          technology that empowers, transforms, and inspires.
        </p>

        {/* ===== Mission Section ===== */}
        <div className="about-section">
          <FaRocket className="about-icon" />
          <div>
            <h2>Our Mission</h2>
            <p>
              To empower businesses through reliable and scalable technology solutions. We aim to simplify complex
              problems with elegant software, and bring ideas to life with creativity, code, and care.
            </p>
          </div>
        </div>

        {/* ===== Vision Section ===== */}
        <div className="about-section">
          <FaLightbulb className="about-icon" />
          <div>
            <h2>Our Vision</h2>
            <p>
              We envision a world where technology is not a barrier, but a bridge – connecting people, powering
              possibilities, and enabling innovation across industries. NEELAverse aims to be the digital backbone
              for businesses of the future.
            </p>
          </div>
        </div>

        {/* ===== Culture Section ===== */}
        <div className="about-section">
          <FaUsers className="about-icon" />
          <div>
            <h2>Our Culture & Values</h2>
            <p>
              At our core, we value innovation, transparency, and teamwork. Every project we take is guided by
              purpose, executed with passion, and delivered with precision. We believe in building not just
              software, but relationships.
            </p>
          </div>
        </div>

        {/* ===== Journey Section ===== */}
        <div className="about-section">
          <FaMapMarkedAlt className="about-icon" />
          <div>
            <h2>Our Journey</h2>
            <p>
              From a small team to a rising name in the IT services space, our journey has been one
              of growth, learning, and continuous improvement. With each milestone, we’ve stayed true to our roots
              – solving real problems for real people using tech that works.
            </p>
          </div>
        </div>

        {/* ===== Board of Directors Section ===== */}
        <div className="about-section board-section">
          <h2>Board of Directors</h2>
          <div className="board-center">
            <img src={sunilImg} alt="Sunil (JSP) Jonnakuti" className="board-image" />
            <h3 className="board-name">Sunil (JSP) Jonnakuti</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
